import {debounceTime} from 'rxjs/operators';
import { Component, Input, OnInit, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
  NotificationService,
  LookupService,
  TypesService,
  ClientService,
} from '../../../services/index';
import { ValidationPartialComponent } from './validation-partial.component';
import { MatOptionModule } from '@angular/material/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { NgIf, NgFor } from '@angular/common';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';

@Component({
    selector: 'app-crumbs-search-partial',
    templateUrl: './crumbs-search-partial.component.html',
    standalone: true,
    imports: [MatFormFieldModule, MatFormFieldModule, FormsModule, ReactiveFormsModule, MatInputModule, MatInputModule, MatAutocompleteModule, MatAutocompleteModule, NgIf, MatButtonModule, MatButtonModule, MatIconModule, MatProgressSpinnerModule, MatProgressSpinnerModule, MatOptionModule, MatOptionModule, NgFor, ValidationPartialComponent]
})
export class CrumbsSearchPartialComponent implements OnInit {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public fieldName: string;
  @Input() public placeholderText: string;
  @Input() public partyRoleSuite: string;
  @Input() public partyRoleType: string;
  @Output() public partyRoleSuiteResults = new EventEmitter<any>();
  public filteredPartyRoleSuites: any;
  public loadingResults = false;
  public partyRoleSuitesTypes = [];
  public partyRoleTypes = [];

  private partyRoleSuitsTypesSlug = 'party-role-suites';
  private partyRoleTypesSlug = 'party-role-types';
  private subscription: any;

  constructor (private typeService: TypesService,
    private clientService: ClientService) {
  }

  ngOnInit() {
    this.populateTypes();
    this.subscription = this.formGroup.get(this.fieldName).valueChanges.pipe(debounceTime(500)).subscribe(this.searchPartyRoleSuite.bind(this));
  }

  populateTypes() {
    this.typeService.getTypesList(this.partyRoleSuitsTypesSlug)
      .then((results) => {
        this.partyRoleSuitesTypes = results;
      });

    this.typeService.getTypesList(this.partyRoleTypesSlug)
      .then((results) => {
        this.partyRoleTypes = results;
      });
  }

  getCrumbsIdFromType(type, slug) {
    const match = type.find(t => t.ext && t.ext.Slug === slug);
    return (match) ? match.id : null;
  }

  addParty(){
    alert('Coming soon');
  }

  searchPartyRoleSuite(query) {
    if (typeof query === 'object') {
      query = this.displayName(query);
    }

    this.loadingResults = true;
    if (!query) {
      query = this.formGroup.get(this.fieldName).value;
    }
    const mock = [
      // {'PartyName': 'Wayne Burnitt Builder', 'PartyRoleID': 698989}
      // {'PartyName': 'No results found', 'PartyRoleID': 0}
      // {"PartyID":789998,"PartyName":"Galilee - WA","PartyTypeID":2,"PartyRoleID":792688,"PartyRoleTypeID":150,"PartyRoleTypeName":"Solicitor","CompanyPartyRoleID":null,"CompanyPartyID":null,"CompanyName":"","Owner":"Julie Sanders","OwnerPartyID":9,"OwnerPartyRoleID":9,"Title":null,"MobilePhoneNumber":null,"WorkPhoneNumber":null,"EmailAddress":null,"ShareCount":0,"PrimaryContactPartyID":856690,"PrimaryContactPartyRoleID":859348,"PrimaryContact":"Samuel Arthur Daniels","AccreditationStatus":"Approved","State":"WA","TontoID":60,"JusticePartyRoleID":6719,"AccountID":null,"Active":true,"TeamTypeName":null,"TeamTypeID":null,"PartyRoleSuiteID":7},
      // {"PartyID":789997,"PartyName":"Galilee - VIC","PartyTypeID":2,"PartyRoleID":792687,"PartyRoleTypeID":150,"PartyRoleTypeName":"Solicitor","CompanyPartyRoleID":null,"CompanyPartyID":null,"CompanyName":"","Owner":"Julie Sanders","OwnerPartyID":9,"OwnerPartyRoleID":9,"Title":null,"MobilePhoneNumber":null,"WorkPhoneNumber":null,"EmailAddress":null,"ShareCount":0,"PrimaryContactPartyID":911007,"PrimaryContactPartyRoleID":913504,"PrimaryContact":"Julie Sanders Orphan Supplier Contact","AccreditationStatus":"Problem","State":"QLD","TontoID":52,"JusticePartyRoleID":6712,"AccountID":null,"Active":true,"TeamTypeName":null,"TeamTypeID":null,"PartyRoleSuiteID":7},
    ];

    if (query) {
      this.clientService.listPartyRoleBySuiteType(
        this.getCrumbsIdFromType(this.partyRoleSuitesTypes, this.partyRoleSuite),
        this.getCrumbsIdFromType(this.partyRoleTypes, this.partyRoleType),
        query)
        .subscribe((results) => {
          console.log('[search results]', results);
          if (results.length === 0) {
            results = mock;
          }
          this.loadingResults = false;
          this.filteredPartyRoleSuites = results;
        }, (err) => {
          console.log('error during search', err);
          this.loadingResults = false;
        });
    } else {
      this.loadingResults = false;
    }
  }

  displayName(object) {
    return (object) ? object.PartyName : null;
  }

  updatedSelectedPrs(party) {
    console.log('[updatedSelectedPrs]', party);
  }

}
